// extracted by mini-css-extract-plugin
export default {"FixedWrapper":"FixedWrapper_FixedWrapper__+gDLg"};